import axios from 'axios';
import { WSREST_TABATA, SITE, NOME_APP } from '../config';



const login = async (username, password) => {
  const loginData = {
    username,
    password,
  };

  try {
    const response = await axios.post(`${WSREST_TABATA}login/${SITE}/${NOME_APP}`, loginData);
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export default {
  login,
};

